import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p1P footer" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "footer-title" }, "About Us", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "textwidget font9 textI2",
  style: {"display":"block"}
}, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0"} }, " 感谢您关注和支持purfuture.com，我在这里分享来自我与学员们，在学习理解性格的过程中，所收获的知识。 希望通过我们分享微薄的力量，能让您在这里，找到解决难题的思路。 "),
  /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0"} }, " 我们并非机构，也不设立或对外投放任何广告进行平台宣传。如发现任何个人或机构，冒充或利用我们的名义，去进行任何盈利性的活动，都是骗子，欢迎微信留言或邮件进行举报。 ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "footer-title" }, "Website Description", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "textwidget font9 textI2",
  style: {"display":"block"}
}, [
  /*#__PURE__*/_createElementVNode("p", { style: {"margin":"0"} }, " 如需解答、咨询、了解、合作及服务的，可在本站底部的邮件方式、右侧的关于我们进行直接咨询。如对本站有任何意见或建议，同样欢迎您向我反馈。我将为帮助我们成长的朋友最大的帮助。 ")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "footer-title colW" }, "Consultation", -1)
const _hoisted_7 = { class: "p1 font9 textI2" }
const _hoisted_8 = { class: "p1 mt10 mb20" }
const _hoisted_9 = { style: {"display":"flex"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "w100p mb5",
  style: {"display":"grid"}
}, [
  /*#__PURE__*/_createElementVNode("p", { class: "purP" }, [
    /*#__PURE__*/_createTextVNode("Copyright © 2016-2023 purfuture.com 个人经验知识分享站 "),
    /*#__PURE__*/_createElementVNode("a", {
      style: {"text-decoration":"underline","color":"rgb(121, 121, 121)"},
      href: "https://beian.miit.gov.cn/"
    }, "粤ICP备19150410号")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_LetterLove = _resolveComponent("b-LetterLove")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_b_LetterCharacter = _resolveComponent("b-LetterCharacter")!
  const _component_b_LetterMarriage = _resolveComponent("b-LetterMarriage")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_Vcode = _resolveComponent("Vcode")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createVNode(_component_a_modal, {
      open: _ctx.visibleLove,
      "onUpdate:open": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.visibleLove) = $event)),
      width: "760px",
      title: "恋爱求助自愈表",
      onOk: _ctx.handleLove,
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_LetterLove)
      ]),
      _: 1
    }, 8, ["open", "onOk"]),
    _createVNode(_component_a_modal, {
      open: _ctx.visibleCharacter,
      "onUpdate:open": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visibleCharacter) = $event)),
      width: "375px",
      title: "性格咨询表",
      onOk: _ctx.handleCharacter,
      footer: null,
      style: {"padding":"0"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_LetterCharacter)
      ]),
      _: 1
    }, 8, ["open", "onOk"]),
    _createVNode(_component_a_modal, {
      open: _ctx.visibleMarriage,
      "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visibleMarriage) = $event)),
      width: "760px",
      title: "婚姻求助自愈表",
      onOk: _ctx.handleMarriage,
      footer: null
    }, {
      default: _withCtx(() => [
        _createVNode(_component_b_LetterMarriage)
      ]),
      _: 1
    }, 8, ["open", "onOk"]),
    _createVNode(_component_a_col, {
      xs: 24,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      class: "p1 fl"
    }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5
      ]),
      _: 1
    }),
    _createVNode(_component_a_col, {
      xs: 24,
      sm: 12,
      md: 12,
      lg: 12,
      xl: 12,
      class: "p1 fl"
    }, {
      default: _withCtx(() => [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createTextVNode("你需要求助？请把你遇到的问题通过下列通道进行提交。如果你不清楚规则，情况紧急，你可以点此通过点击（"),
          _createElementVNode("a", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showLove && _ctx.showLove(...args)))
          }, "感情"),
          _createTextVNode("、"),
          _createElementVNode("a", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.showMarriage && _ctx.showMarriage(...args)))
          }, "婚姻"),
          _createTextVNode("）填写求助模板，进行咨询信息提交。（1个工作日内）将给予回复。")
        ]),
        _createElementVNode("form", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_Vcode, {
              show: _ctx.isShow,
              onSuccess: _ctx.onSuccess,
              onClose: _ctx.onClose
            }, null, 8, ["show", "onSuccess", "onClose"]),
            _createVNode(_component_a_textarea, {
              "show-count": "",
              maxlength: 500,
              minlength: 10,
              value: _ctx.email.comment,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.email.comment) = $event)),
              class: "footerTextarea",
              name: "openSendEmailBody",
              type: "textarea",
              rows: "5",
              placeholder: "输入邮件内容"
            }, null, 8, ["value"]),
            _createVNode(_component_a_button, {
              onClick: _ctx.onShow,
              disabled: _ctx.email.comment.length > 10 && _ctx.email.comment.length <500 ? false : true,
              style: {"background-color":"lightgray","height":"auto","width":"30%"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 发送 ")
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ])
        ])
      ]),
      _: 1
    }),
    _hoisted_10
  ]))
}